import React from "react";

export const FleshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none">
      <path
        d="M2.5 7H12.5M12.5 7L9 10.5M12.5 7L9 3.5"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
